/* eslint-disable @typescript-eslint/naming-convention */

import { gql } from "@apollo/client";
import { PostInfoV2WithDerivatives, PostCollectionInfoV2 } from "./fragments";

export const FetchPlaylistAllPostsPaginatedByRankV2 = gql`
  ${PostInfoV2WithDerivatives}
  query FetchPlaylistAllPostsPaginatedByRank(
    $postCollectionId: ID!
    $nextPageToken: String
  ) {
    searchPostCollectionMemberships(
      filter: { postCollection_id: { eq: $postCollectionId } }
      sort: { field: rank, direction: asc }
      limit: 100
      nextToken: $nextPageToken
    ) {
      nextToken
      items {
        post {
          ...PostInfoV2WithDerivatives
        }
      }
    }
  }
`;

export const FetchPlaylistAllPostsPaginatedByLatestV2 = gql`
  ${PostInfoV2WithDerivatives}
  query FetchPlaylistAllPostsPaginatedByLatest(
    $postCollectionId: ID!
    $nextPageToken: String
  ) {
    searchPostCollectionMemberships(
      filter: { postCollection_id: { eq: $postCollectionId } }
      sort: { field: createdAt, direction: desc }
      limit: 100
      nextToken: $nextPageToken
    ) {
      nextToken
      items {
        post {
          ...PostInfoV2WithDerivatives
        }
      }
    }
  }
`;

export const FetchPlaylistInfoV2 = gql`
  ${PostCollectionInfoV2}
  query FetchPlaylistInfo($postCollectionId: ID!) {
    getPostCollection(id: $postCollectionId) {
      ...PostCollectionInfoV2
    }
  }
`;
